module.exports = __webpack_public_path__ + "static/media/asset_2.00194504.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/asset_2.jpg
// module id = 308
// module chunks = 0